import request from '../../utils/request';

export function signIn(params) {
  return request('/auth/login', {
    method: 'POST',
    data: params,
  });
}

export function signUp(params) {
  return request('/auth/register', {
    method: 'POST',
    data: params,
  });
}

export function adminSignIn(params) {
  return request('/auth/admin-login', {
    method: 'POST',
    data: params,
  });
}

export function getProfile() {
  return request('/auth/profile', {
    method: 'GET',
  });
}

// Admin "view as driver" dry-run — mint a short-lived driver session for the
// route's driver. The caller opens the driver PWA with the returned token.
export function impersonateDriver(routeId) {
  return request(`/auth/impersonate-driver/${routeId}`, {
    method: 'POST',
  });
}

// Aug 2026 — REAL driver-app login as a driver (support tool): unlike the
// dry-run, actions performed in the opened tab persist.
export function impersonateDriverLogin(driverId) {
  return request(`/auth/impersonate-driver-login/${driverId}`, {
    method: 'POST',
  });
}

export function changePassword(params) {
  return request('/auth/change-password', {
    method: 'POST',
    data: params,
  });
}

// Admin -> partner-viewer impersonation. Returns a short-lived JWT scoped to
// the target partner; frontend swaps the current cookie for it after stashing
// the admin token in sessionStorage so "Exit impersonation" can restore.
export function impersonatePartnerViewer(partnerId) {
  return request(`/auth/impersonate-partner-viewer/${partnerId}`, {
    method: 'POST',
  });
}

export function exitImpersonation() {
  return request('/auth/exit-impersonation', {
    method: 'POST',
  });
}

// ── OVO-159 — TOTP two-factor auth ──────────────────────────────────────────
// setup/enable accept an explicit token because during forced enrollment the
// caller only holds the setup-scoped token from login (not yet in the cookie).

export function twoFactorSetup(token) {
  return request('/auth/2fa/setup', {
    method: 'POST',
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
  });
}

export function twoFactorEnable(code, token) {
  return request('/auth/2fa/enable', {
    method: 'POST',
    data: { code },
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
  });
}

export function twoFactorVerify(preAuthToken, code) {
  return request('/auth/2fa/verify', {
    method: 'POST',
    data: { preAuthToken, code },
  });
}
